<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="dissertation"
        :is-no-changes="isNoChanges"
        @save="saveDissertation"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="workTypeRusName(workTypeName.Dissertation)" />

          <AuthorsCard
            title="Соискатель"
            class="mt-4"
            :max-authors="1"
            :selected-item.sync="dissertation.commonWork.authors"
            :is-show-mode="isShowMode"
            @updateInvalid="updateAuthorsInvalid"
          />

          <DissertationCard
            class="mt-4"
            title="Основная информация"
            :selected-item.sync="dissertation"
            :is-show-mode="isShowMode"
            @updateInvalid="updateDissertationInvalid"
          />

          <SpecialityCard
            class="mt-4"
            :is-show-mode="isShowMode"
            :is-no-required-fields="dissertation.isPHD"
            :selected-item.sync="dissertation.dissertationSpeciality"
            @updateInvalid="updateSpecialityInvalid"
          />

          <CommentCard
            v-if="Boolean(dissertation.commonWork.comment)"
            class="mt-4"
            :comment="dissertation.commonWork.comment"
          />

          <CreatorCard :creator-name="dissertation.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { dissertationApi } from '@/api'
import DissertationCard from '../../components/Works/Dissertation/DissertationCard'
import { Dissertation } from '../../models'
import TitleCard from '@/components/Works/elements/TitleCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import SpecialityCard from '@/components/Works/elements/SpecialityCard.vue'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'

export default {
  name: 'DissertationPage',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.Dissertation)
    }
  },

  components: {
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    AuthorsCard,
    TitleCard,
    DissertationCard,
    SpecialityCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    dissertation: new Dissertation(),
    dataLoaded: false,
    saveBtnLoading: false,
    authorsInvalid: false,
    dissertationInvalid: false,
    specialityInvalid: false,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.authorsInvalid || this.dissertationInvalid || this.specialityInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode)
        await this.getDictionaries([
          dictionaryNames.DissertationDegree,
          dictionaryNames.ProtectionPlace,
          dictionaryNames.ScienceStep,
          dictionaryNames.Speciality
        ])
      await this.getWorkTypes()
      await this.getDissertation()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getDissertation() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await dissertationApi.get(this.$route.params?.id)
          this.dissertation = new Dissertation(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveDissertation(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.dissertation.id) {
          this.dissertation.commonWork.workType = this.workTypeByName(workTypeName.Dissertation)
        }

        const body = this.dissertation.getForAPI()

        if (!body.dissertationSpeciality[0]?.speciality) {
          body.dissertationSpeciality = []
        }

        const data = this.dissertation.id ? await dissertationApi.update(body) : await dissertationApi.create(body)

        if (!this.dissertation.id) await this.$router.replace('/works/dissertation/edit/' + data.id)

        this.dissertation = new Dissertation(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    async updateDissertationInvalid(val) {
      this.dissertationInvalid = val
      this.isNoChanges = false
    },

    async updateSpecialityInvalid(val) {
      this.specialityInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveDissertation
    }
  }
}
</script>

<style scoped></style>
